import { render, staticRenderFns } from "./TxProductViewPortal.vue?vue&type=template&id=5157a2c6&scoped=true&"
import script from "./TxProductViewPortal.vue?vue&type=script&lang=js&"
export * from "./TxProductViewPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157a2c6",
  null
  
)

export default component.exports